<template>
	<div class="row">
		<div class="col-sm-4">
			<b>Colaborador</b>
			<drop-draw :asset="filterPatients" v-model="search.patients" />
		</div>
		<div class="col-sm-3">
			<b>Unidade</b>
			<drop-draw
				:asset="assets.unidades"
				v-model="search.unidade"
				radio
			/>
		</div>
		<div class="col-sm-3">
			<b>Convocação</b>
			<input type="month" class="form-control" />
		</div>
		<div class="col-sm-2">
			<b>Coleta*</b>
			<div class="input-group">
				<span class="input-group-addon">
					<i v-if="!isDataSel" class="fa fa-calendar"></i>
					<i
						v-else
						@click="search.dateOne = search.dateTwo = ''"
						class="fa fa-calendar-times-o"
					></i>
				</span>
				<div class="form-control" id="datepicker-trigger-2">
					<template v-if="!isDataSel"> Escolher </template>
					<template v-else>
						{{ fDate(search.dateOne) }} -
						{{ fDate(search.dateTwo) }}
					</template>
				</div>
			</div>
			<div class="cnt-airbnb">
				<div class="airbnb">
					<AirbnbStyleDatepicker
						trigger-element-id="datepicker-trigger-2"
						:mode="'range'"
						:months-to-show="2"
						:date-one="search.dateOne"
						:date-two="search.dateTwo"
						:fullscreen-mobile="true"
						@date-one-selected="
							(val) => {
								search.dateOne = val;
							}
						"
						@date-two-selected="
							(val) => {
								search.dateTwo = val;
							}
						"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	import fDate from 'js/date';
	import DropDraw from 'app/drop-draw';

	export default {
		inject: ['assets'],
		components: { DropDraw },
		data() {
			return {
				search: {
					patients: [],
					unidade: '',
					dateOne: '',
					dateTwo: '',
				},

				pacients: [],
			};
		},
		computed: {
			filterPatients() {
				if (this.search.unidade == '') return this.pacients;
				else
					return this.pacients.filter((item) => {
						if (item.unidade == this.search.unidade) return item;
					});
			},
			isDataSel() {
				return this.search.dateOne != '' || this.search.dateTwo != '';
			},
		},
		methods: {
			filter() {
				let filters = [];

				// Pesquisando pacientes
				if (this.search.patients.length > 0) {
					let fPatients = [];
					this.search.patients.forEach((item) => {
						fPatients.push(` \`matricula\` = ${item} `);
					});
					filters.push(' ( ' + fPatients.join(' or ') + ' ) ');
				}

				// Pesquisando unidades
				if (this.search.unidade != '') {
					filters.push(` \`unidade\` = '${this.search.unidade}' `);
				}

				// Pesquisando data de coleta
				if (this.isDataSel) {
					const dIn = this.search.dateOne;
					const dOut = this.search.dateTwo;
					filters.push(
						` ( \`coleta\` >= '${dIn}' and \`coleta\` <= '${dOut}' ) `
					);
				}

				return filters.join(' and ');
			},
			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return fDate(date, mask);
			},
			loadPatients(serach = '') {
				WBS.send(
					'protected-read-listPatientssd2000',
					{ search: serach },
					(resp) => {
						if (resp.data == undefined) this.pacients = [];
						else
							this.pacients = resp.data.reduce((acc, item) => {
								acc.push({
									cod: item.mat,
									title: item.nome,
									unidade: item.unidade.replace(/ /g, ''),
								});
								return acc;
							}, []);
					}
				);
			},
		},
		mounted() {
			this.loadPatients();
		},
	};
</script>
<style>
	.airbnb-style-datepicker-wrapper {
		position: absolute !important;
		width: 600px !important;
		z-index: 100 !important;
		top: 41px !important;
		right: 0px !important;
		left: 0px !important;
	}
	div.datepicker-inner-wrapper {
		margin: 3px 0 0 0 !important;
	}
	.airbnb {
		position: absolute;
		right: 601px;
		top: -40px;
	}
	.cnt-airbnb {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/components/filter.vue